var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { staticClass: "job-list", style: { height: "100%" } },
    [
      _vm.runningCount == 0 && _vm.queuedCount == 0
        ? _c("w-notification-item", {
            attrs: {
              icon: "check",
              tone: "success",
              title: _vm.$ct("no-jobs"),
            },
          })
        : _c("w-notification-item", {
            attrs: {
              icon: "hourglass-half",
              tone: "neutral",
              title: _vm.summary,
            },
          }),
      _vm._l(_vm.jobs, function (job) {
        return _c(
          "w-notification-item",
          {
            key: job.getID(),
            attrs: {
              tone: job.ShouldCancel
                ? "danger"
                : job.isRunning
                ? "info"
                : "neutral",
              title: job.getName(),
              subtitle: job.getStatusMessage(),
              time: job.isRunning ? "" : _vm.$ct("queued"),
            },
          },
          [
            _c(
              "template",
              { slot: "icon" },
              [
                job.ShouldCancel
                  ? _c("w-fa", { attrs: { icon: "stop" } })
                  : job.isRunning
                  ? [
                      job.hasProgressBar()
                        ? _c("w-progress-circular", {
                            attrs: {
                              multiplier: 0.4,
                              value: job.getProgressBarValue(),
                            },
                          })
                        : _c("w-progress-circular", {
                            attrs: { multiplier: 0.4 },
                          }),
                    ]
                  : _c("w-fa", { attrs: { icon: "hourglass-start" } }),
              ],
              2
            ),
            !job.isRunning
              ? _c(
                  "w-button",
                  {
                    staticClass: "danger",
                    attrs: { ghost: "", sm: "", icon: "ban" },
                    on: {
                      click: function ($event) {
                        return _vm.removeJobFromQueue(job)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$ct("remove-job-from-queue")) + " ")]
                )
              : job.Cancellable
              ? [
                  !job.ShouldCancel
                    ? _c(
                        "w-button",
                        {
                          staticClass: "danger",
                          attrs: { ghost: "", sm: "", icon: "stop" },
                          on: {
                            click: function ($event) {
                              return _vm.cancelJob(job)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$ct("cancel-job")) + " ")]
                      )
                    : _c(
                        "w-button",
                        {
                          attrs: { ghost: "", sm: "", icon: "play" },
                          on: {
                            click: function ($event) {
                              return _vm.uncancelJob(job)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$ct("uncancel-job")) + " ")]
                      ),
                ]
              : _vm._e(),
          ],
          2
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }